<template>
    <div>

        <SchedulerRON v-if="Store.Checkout.Cart.SelectedService == 'RONNotarization'">
        </SchedulerRON>

        <SchedulerFieldNotary v-if="Store.Checkout.Cart.SelectedService == 'FieldNotarization'">
        </SchedulerFieldNotary>

        <SchedulerCourier v-if="Store.Checkout.Cart.SelectedService == 'CourierDelivery'">
        </SchedulerCourier>

        <SchedulerFieldInspection v-if="Store.Checkout.Cart.SelectedService == 'FieldInspection'">  
        </SchedulerFieldInspection>

        <SchedulerApostille v-if="Store.Checkout.Cart.SelectedService == 'Apostille'">           
        </SchedulerApostille>

    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';


    import 'air-datepicker/air-datepicker.css';


    import { useEditorStore } from '/src/stores/EditorStore';

    import SchedulerRON from '@components/checkout/SchedulerRON.vue';
    import SchedulerApostille from '@components/checkout/SchedulerApostille.vue';
    import SchedulerCourier from '@components/checkout/SchedulerCourier.vue';
    import SchedulerFieldInspection from '@components/checkout/SchedulerFieldInspection.vue';
    import SchedulerFieldNotary from '@components/checkout/SchedulerFieldNotary.vue';

    export default {
        inheritAttrs: false,
        name: 'CheckoutSchedulerSelect',
        mixins: [],
        props: ['modelValue', 'selectedservice', 'ronconfig', 'fieldnotaryconfig', 'courierconfig', 'apostilleconfig', 'fieldinspectionconfig'],
        emits: ['update:modelValue'],
        components: {
            SchedulerRON,
            SchedulerApostille,
            SchedulerCourier,
            SchedulerFieldInspection,
            SchedulerFieldNotary
        },
        computed:
        {
        },
        watch: {
        },
        data() {
            return {
                Store: {},
            };
        },
        methods:
        {
               
        },
        created() {
            this.Store = useEditorStore();
        },
        beforeUnmount() {
        },
        mounted() {      
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .RedDotDate {
        font-weight: bold;
    }

    .RedDotDate::after {
        content: '';
        display: block;
        width: 3px; /* Size of the dot */
        height: 3px; /* Size of the dot */
        background-color: red;
        border-radius: 50%; /* Makes it round */
        position: absolute;
        bottom: 5px; /* Adjusts vertical position */
        left: 50%; /* Centers the dot horizontally */
        transform: translateX(-50%); /* Ensures it is centered */
    }

    .dots-fill {
        overflow: hidden;
        white-space: nowrap;
    }

        .dots-fill .dots-after:after {
            content: " ....................................................................................................................................................................";
        }

    .highlight-hover:hover {
        background-color: #e4ffd9
    }

    .flip-enter-active {
        transition: all 0.4s ease;
    }

    .flip-leave-active {
        display: none;
    }

    .flip-enter, .flip-leave {
        transform: rotateY(180deg);
        opacity: 0;
    }

    .light-info {
        color: rgba(10, 191, 83, 0.5) !important;
    }

    .numberCircle {
        position: relative;
        top: -8px;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        padding: 4px;
        padding-top: 8px;
        background: rgba(10, 191, 83, 0.5);
        border: 2px solid limegreen;
        color: white;
        text-align: center;
        font: 14px Arial, sans-serif;
    }

    .checkout-content {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        z-index: 1;
    }

        .checkout-content::before {
            content: "";
            display: block;
            position: absolute;
            z-index: -1;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(255,255,255,.8);
        }

        /* Style the content inside .contact-checkout-content */
        .checkout-content .row {
            color: #fff;
        }
</style>

